import classNames from 'classnames';
import React from 'react';

import styles from './switch.module.css';

export interface SwitchProps {
  checked?: boolean | undefined;
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined;
  className?: string;
  sliderClassName?: string;
}

export const Switch = ({ checked, onChange, className, sliderClassName }: SwitchProps) => {
  const wrapperClassNames = classNames({
    [styles['fn-switch']]: true,
    [className || '']: !!className,
  });
  const sliderClassNames = classNames({
    [styles['fn-switch-slider']]: true,
    [sliderClassName || '']: !!sliderClassName,
  });
  return (
    <label className={wrapperClassNames} aria-label="switch component">
      <input type="checkbox" checked={checked} onChange={onChange} aria-label="switch component" />
      <span className={sliderClassNames} />
    </label>
  );
};
